import React from "react";
import { CloseIcon, RoundedChecklistIcon } from "../../../../../../components/icons"
import { useBookingEditText } from "../../../text";

const SuccessSubmitEditBookingModal = ({
    show,
    onClose,
    oldBooking,
    userDeferredPaymentEligible = false,
    editFeeCalculation,
    calculatedEditBooking,
}) => {
    const { t } = useBookingEditText();

    return (
        <div className={`tw:fixed tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center ${show ? "tw:block" : "tw:hidden"}`}>
            <div
                aria-label="Close modal backdrop"
                className="tw:absolute tw:inset-0 tw:bg-[#00000099]"
                onClick={onClose}
            />
            <div className="tw:relative tw:z-[10000] tw:w-[calc(100%-24px)] tw:lg:w-[660px] tw:rounded-[8px] tw:bg-white tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8 tw:shadow-lg">
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Close"
                    className="tw:absolute tw:top-6 tw:right-6"
                >
                    <CloseIcon color="#7c7b7b" size={16} />
                </button>

                <div className="tw:!text-center tw:!mt-4 tw:!mb-6">
                    <div className="tw:flex tw:items-center tw:justify-center tw:mb-2">
                        <RoundedChecklistIcon color="#3CAEA3" size={24} />
                    </div>

                    <div className="tw:text-[#3CAEA3] tw:!text-[20px] tw:leading-[38px] tw:!font-[600] tw:font-hanken-grotesk tw:mb-0">
                        {
                            oldBooking.paymentStatus === "CHARGE_PENDING" ? t("editBooking.BookingReviewPage.successSubmitEditBookingModal.title.bookingUpdated") : t("editBooking.BookingReviewPage.successSubmitEditBookingModal.title.modificationRequestSubmitted")
                        }
                    </div>
                </div>

                {oldBooking.paymentStatus === "CHARGE_PENDING" ? (
                    <>
                        {
                            !userDeferredPaymentEligible ? (
                                <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:mt-6 tw:md:mt-2 tw:mb-2">
                                    <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.unconfirmed.advancePayment.one")
                                        }}
                                    ></p>
                                    <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.unconfirmed.advancePayment.two")
                                        }}
                                    ></p>
                                </div>
                            ) : (
                                <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:mt-6 tw:md:mt-2 tw:mb-2">
                                    <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.unconfirmed.deferredPayment.one")
                                        }}
                                    ></p>
                                    <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.unconfirmed.deferredPayment.two")
                                        }}
                                    ></p>
                                </div>
                            )
                        }
                    </>
                ) : (
                    <>
                        {
                            userDeferredPaymentEligible ? (
                                <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:mt-6 tw:md:mt-2 tw:mb-2">
                                    <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.confirmed.deferredPayment.one")
                                        }}
                                    ></p>
                                    <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.confirmed.deferredPayment.two")
                                        }}
                                    ></p>
                                </div>
                            ) : (
                                ((oldBooking.totalPrice > (calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee)) || (oldBooking.totalPrice === (calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee))) ? (
                                    <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:mt-6 tw:md:mt-2 tw:mb-2">
                                        <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.confirmed.advancePayment.lower.one")
                                            }}
                                        ></p>
                                    </div>
                                ) : (
                                    <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:mt-6 tw:md:mt-2 tw:mb-2">
                                        <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.confirmed.advancePayment.higher.one", {
                                                    additionalAmount: ((calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee) - oldBooking.totalPrice).toLocaleString()
                                                })
                                            }}
                                        ></p>
                                        <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.confirmed.advancePayment.higher.two")
                                            }}
                                        ></p>
                                        <p className="tw:!text[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:!mb-0"
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.successSubmitEditBookingModal.content.confirmed.advancePayment.higher.three")
                                            }}
                                        ></p>
                                    </div>
                                )
                            )
                        }
                    </>
                )}
            </div>
        </div>
    );
}

export default SuccessSubmitEditBookingModal;
